export const SPECS = {
  CallCartV2FromExpressCheckout: 'specs.ecom.CallCartV2FromExpressCheckout',
  CheckoutUIRevampOrderSummary: 'specs.ecom.CheckoutUIRevampOrderSummary'
};
//# sourceMappingURL=SPECS.js.map